import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';

const TODAS_UFS = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];

function fmtDataEmissao(v) {
  if (!v) return '—';
  const s = typeof v === 'string' ? v : v instanceof Date ? v.toISOString() : String(v);
  const [y, m, d] = s.split('T')[0].split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}



function Configuracoes() {
  const navigate = useNavigate();
  const [versoes, setVersoes] = useState([]);
  const [arquivo, setArquivo] = useState(null);
  const [ufs, setUfs] = useState([]);
  const [tipos, setTipos] = useState(['SD','CD','SE']);
  const [analitico, setAnalitico] = useState(false);
  const [importando, setImportando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [temSinapi, setTemSinapi] = useState(true);
  const fileRef = useRef();

  async function carregarVersoes() {
    try {
      const r = await api.get('/sinapi/versoes');
      setVersoes(r.data);
    } catch { }
  }

  async function carregarPreferencias() {
    try {
      const r = await api.get('/configuracoes-sistema');
      if (r.data.ufs_padrao) setUfs(JSON.parse(r.data.ufs_padrao));
      if (r.data.tipos_padrao) setTipos(JSON.parse(r.data.tipos_padrao));
    } catch { }
  }

  async function salvarPreferencias() {
    try {
      await Promise.all([
        api.put('/configuracoes-sistema/ufs_padrao', { valor: JSON.stringify(ufs) }),
        api.put('/configuracoes-sistema/tipos_padrao', { valor: JSON.stringify(tipos) }),
      ]);
      toast.success('Preferências salvas!');
    } catch {
      toast.error('Erro ao salvar preferências.');
    }
  }

  useEffect(() => {
    api.get('/tenant/status').then(r => {
      setTemSinapi(r.data.funcionalidades?.sinapi ?? true);
    }).catch(() => {});
    carregarVersoes();
    carregarPreferencias();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toggleUf(uf) {
    setUfs(prev => prev.includes(uf) ? prev.filter(u => u !== uf) : [...prev, uf]);
  }

  function toggleTipo(t) {
    setTipos(prev => prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t]);
  }

  function toggleTodosUfs() {
    setUfs(ufs.length === TODAS_UFS.length ? [] : [...TODAS_UFS]);
  }

  async function importar() {
    if (!arquivo) { toast.error('Selecione o arquivo SINAPI_Referência.xlsx'); return; }
    if (!ufs.length) { toast.error('Selecione ao menos um estado.'); return; }
    if (!tipos.length) { toast.error('Selecione ao menos um tipo de encargo.'); return; }

    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('ufs', JSON.stringify(ufs));
    formData.append('tipos', JSON.stringify(tipos));
    formData.append('analitico', analitico ? 'true' : 'false');

    setImportando(true);
    setResultado(null);
    try {
      const r = await api.post('/sinapi/importar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000,
      });
      setResultado(r.data);
      toast.success('Importação concluída!');
      setArquivo(null);
      if (fileRef.current) fileRef.current.value = '';
      carregarVersoes();
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao importar arquivo.', { duration: 8000 });
    } finally {
      setImportando(false);
    }
  }

  async function ativarVersao(id) {
    try {
      await api.put(`/sinapi/versoes/${id}/ativar`);
      toast.success('Versão ativada!');
      carregarVersoes();
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao ativar versão.');
    }
  }

  async function deletarVersao(id, mes) {
    if (!window.confirm(`Remover a versão ${mes}? Esta ação é irreversível.`)) return;
    try {
      await api.delete(`/sinapi/versoes/${id}`);
      toast.success('Versão removida!');
      carregarVersoes();
    } catch (err) {
      toast.error(err.response?.data?.mensagem || 'Erro ao remover versão.', { duration: 6000 });
    }
  }

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>⚙️ Configurações</h2>

      {/* SINAPI Import */}
      <div className="card">
        <h3>📥 Importar Tabela SINAPI</h3>
        {!temSinapi && (
          <div style={{ textAlign: 'center', padding: '32px 24px' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
            <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8 }}>Disponível a partir do Plano Prata</div>
            <div style={{ fontSize: 14, color: 'var(--text-secondary, #6b7280)', maxWidth: 480, margin: '0 auto 20px' }}>
              O SINAPI (Sistema Nacional de Pesquisa de Custos e Índices da Construção Civil) é a tabela oficial da Caixa Econômica Federal
              com preços de mão de obra, materiais e equipamentos para toda obra civil no Brasil.
              Com ele, você gera orçamentos precisos e dentro das normas, evitando perdas e disputas com clientes.
            </div>
            <button className="btn-primary" onClick={() => navigate('/plano')}>
              Ver planos e fazer upgrade →
            </button>
          </div>
        )}
        {temSinapi && <>
        <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
          Faça o download do arquivo <strong>SINAPI_Referência_AAAA_MM.xlsx</strong> no site da Caixa Econômica Federal (
          <a href="https://www.caixa.gov.br/site/Paginas/downloads.aspx#categoria_888" target="_blank" rel="noreferrer" style={{ color: 'var(--azul-medio)' }}>
            clique aqui
          </a>
          ) e importe aqui. Cada importação cria uma nova versão que pode ser ativada ou desativada.
        </p>

        <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>
          Arquivo SINAPI_Referência (.xlsx) *
        </label>
        <input
          ref={fileRef}
          type="file"
          accept=".xlsx"
          onChange={e => setArquivo(e.target.files[0])}
          style={{ marginBottom: 20 }}
        />

        <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 8 }}>
          Estados a importar *
        </label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <button
            className="btn-secondary"
            style={{ fontSize: 12, padding: '4px 10px' }}
            onClick={toggleTodosUfs}
          >
            {ufs.length === TODAS_UFS.length ? 'Desmarcar todos' : 'Selecionar todos'}
          </button>
          <button
            className="btn-secondary"
            style={{ fontSize: 12, padding: '4px 10px' }}
            onClick={salvarPreferencias}
            title="Salva os estados e tipos de encargo marcados como padrão para próximas importações"
          >
            💾 Salvar como padrão
          </button>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 12px', marginBottom: 20 }}>
          {TODAS_UFS.map(uf => (
            <label key={uf} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={ufs.includes(uf)} onChange={() => toggleUf(uf)} />
              <strong>{uf}</strong>
            </label>
          ))}
        </div>

        <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 8 }}>
          Tipos de encargo *
        </label>
        <p style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
          SD = Sem Desoneração · CD = Com Desoneração · SE = Sem Encargos Sociais
        </p>
        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          {['SD','CD','SE'].map(val => (
            <label key={val} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={tipos.includes(val)} onChange={() => toggleTipo(val)} />
              <strong>{val}</strong>
            </label>
          ))}
        </div>

        <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 8 }}>
          Detalhamento
        </label>
        <p style={{ fontSize: 12, color: '#666', marginBottom: 10 }}>
          Analítico = importa quais insumos e sub-composições formam cada composição, com a quantidade de cada um. Usado em Obras → Materiais para lançar os itens que compõem um serviço em vez do preço total fechado.
        </p>
        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={analitico} onChange={() => setAnalitico(a => !a)} />
            <strong>Analítico</strong>
          </label>
        </div>

        <button className="btn-primary" onClick={importar} disabled={importando}>
          {importando ? '⏳ Importando... (pode levar alguns minutos)' : '📥 Importar'}
        </button>

        {importando && (
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 12 }}>
            Processando o arquivo e inserindo os dados no banco. Aguarde, não feche esta página.
          </p>
        )}

        {resultado && (
          <div style={{ marginTop: 16, padding: '12px 16px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 8 }}>
            <strong style={{ color: '#14532d' }}>✅ Importação concluída ({resultado.mes_referencia})</strong>
            <div style={{ fontSize: 13, marginTop: 6, color: '#166534' }}>
              {resultado.insumos.toLocaleString('pt-BR')} insumos · {resultado.composicoes.toLocaleString('pt-BR')} composições
              {resultado.itens_analitico > 0 && <> · {resultado.itens_analitico.toLocaleString('pt-BR')} itens analíticos</>}
              · Estados: {resultado.ufs.join(', ')}
            </div>
          </div>
        )}
        </>}
      </div>

      {/* Versões importadas */}
      <div className="card">
        <h3>📋 Versões Importadas</h3>
        {versoes.length === 0 ? (
          <p style={{ color: '#9ca3af', fontSize: 13, fontStyle: 'italic' }}>
            Nenhuma versão importada ainda.
          </p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Mês Ref.</th>
                <th>Data Emissão</th>
                <th>Importado em</th>
                <th>Insumos</th>
                <th>Composições</th>
                <th>Analítico</th>
                <th>Estados</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {versoes.map(v => (
                <tr key={v.sinapi_versao_id}>
                  <td data-label="Mês Ref."><strong>{v.mes_referencia}</strong></td>
                  <td data-label="Data Emissão">{fmtDataEmissao(v.data_emissao)}</td>
                  <td data-label="Importado em">{new Date(v.data_importacao).toLocaleDateString('pt-BR')}</td>
                  <td data-label="Insumos">{parseInt(v.total_insumos).toLocaleString('pt-BR')}</td>
                  <td data-label="Composições">{parseInt(v.total_composicoes).toLocaleString('pt-BR')}</td>
                  <td data-label="Analítico">{v.tem_analitico ? '✅' : '—'}</td>
                  <td data-label="Estados" style={{ fontSize: 12 }}>{(v.ufs_importadas || []).join(', ')}</td>
                  <td data-label="Status">
                    {v.ativa
                      ? <span className="badge badge-concluida">Ativa</span>
                      : <span className="badge" style={{ background: '#f3f4f6', color: '#6b7280' }}>Inativa</span>}
                  </td>
                  <td data-label="Ações">
                    <div style={{ display: 'flex', gap: 6 }}>
                      {!v.ativa && (
                        <button className="btn-primary" style={{ fontSize: 12, padding: '4px 10px' }}
                          onClick={() => ativarVersao(v.sinapi_versao_id)}>
                          Ativar
                        </button>
                      )}
                      {!v.ativa && (
                        <button className="btn-danger" style={{ fontSize: 12, padding: '4px 10px' }}
                          onClick={() => deletarVersao(v.sinapi_versao_id, v.mes_referencia)}>
                          Remover
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Configuracoes;
